import { defineStore } from "pinia";
import { withErrorHandling } from "~/helpers/withErrorHandling";
import { withErrorMessage } from "~/helpers/withErrorMessage";
import { withLoading } from "~/helpers/withLoading";
import {
  getConfigVariables,
  updateConfigVariable,
} from "~/model/api/pLCnextStoreFrontendAPI";
import {
  type WebModelGetConfigVar,
  WebModelGetConfigVarVarName,
  type WebModelPutConfigVar,
} from "~/model/api/pLCnextStoreFrontendAPI.schemas";

interface State {
  configurations: WebModelGetConfigVar[];
}

export const useConfigurationsStore = defineStore("configurations", {
  // convert to a function
  state: (): State => ({
    configurations: [], // initial state
  }),
  getters: {
    getConfigVar: (state) => {
      return (
        configVarName: WebModelGetConfigVarVarName,
      ): WebModelGetConfigVar | undefined => {
        return state.configurations.find(
          (c: WebModelGetConfigVar) => c.varName === configVarName,
        );
      };
    },
    getBannerText(): string | undefined {
      const s = this.configurations.find(
        (c: WebModelGetConfigVar) =>
          c.varName === WebModelGetConfigVarVarName.MaintenanceBannerText,
      )?.varValue;

      return (s as unknown as string) || undefined;
    },
    getActiveUsers(): string | undefined {
      const s = this.configurations.find(
        (c: WebModelGetConfigVar) =>
          c.varName === WebModelGetConfigVarVarName.DsaReportActivUsersText,
      )?.varValue;

      return (s as unknown as string) || undefined;
    },
  },
  actions: {
    async loadConfigurationVariables() {
      const { data, error } = await withErrorHandling(
        withErrorMessage(withLoading(getConfigVariables())),
      );
      console.debug("loadConfigurationVariables: ", data, error);
      if (data) {
        this.configurations = data;
      }
    },

    async updateConfigurationVariable(
      webModelPutConfigVar: WebModelPutConfigVar,
    ) {
      const { data } = await withErrorMessage(
        withLoading(updateConfigVariable(webModelPutConfigVar)),
      );
      console.debug("updateConfigurationVariable: ", data);
    },

    // easily reset state using `$reset`
    clear() {
      this.$reset();
    },
  },
});
